import { Color, Graphics, MigButton, MigScreen, Rect, Vec2 } from "miglib";
import { RenderUtil } from "./RenderUtil";
import { globals } from "./types";
import { GameScreen } from "./GameScreen";
import { setCurrentScreen } from "./main";
import { SaveManager } from "./SaveManager";

export class MenuScreen implements MigScreen {

    currentWind = 2;
    targetWind = 2;
    minWind = 2;
    maxWind = 5;

    difficulty = 2;
    difficultyNames = ["FREE", "EASY", "MEDIUM", "HARD", "IMPOSSIBLE"]

    worldSize = 2;
    worldSizeNames = ["TINY", "SMALL", "MEDIUM", "BIG", "HUGE"]

    private wasMouseDown = false;
    mouseJustPressed = false;

    isTutorialOn = true;
    tutorialDifficulty = 1
    tutorialSize = 2

    isShowingKeys = false;

    music = 1;
    sound = 2;

    onShow(g: Graphics): void {

        this.load();
        this.save();

        g.sketch.textFont(globals.font);
        g.sketch.textLeading(8);

        for (let i = 0; i < 300; i++) {
            this.spawnDustParticles(g, true);
        }

        globals.audio.setMusicEnabled(this.music !== 0)
        globals.audio.setMusicVolume(this.music / 5);
        globals.audio.setSoundEnabled(this.sound !== 0)
        globals.audio.setSoundVolume(this.sound / 5);
        // this.startGame(true); // TODO
    }

    hoveredUI: any = null
    prevHoveredUI: any = null

    onRender(g: Graphics): void {

        const savedGameExists = SaveManager.hasSave();
        const zoom = 4;
        const mxy: Vec2 = { x: g.mx / zoom, y: g.my / zoom };
        g.sketch.background(0);

        this.mouseJustPressed = g.mouseIsPressed && !this.wasMouseDown;

        this.spawnDustParticles(g);

        g.sketch.push();
        g.sketch.scale(zoom);

        const logoW = g.assets.getImage("logo").width;
        g.renderImage("logo", g.width / zoom / 2 - logoW / 2, 13);

        const cx = Math.floor(g.width / 4 / 2);
        let y = g.height / zoom - 24 - 24 - 24 - 24;
        const devFromMid = 48;

        g.renderText("", 0, 0, { color: Color.col(255, 255, 255), size: 5 })

        this.hoveredUI = null;
        if (this.isShowingKeys) {

            y += 24;

            const tx = cx - 100;
            const ty = y - 34;
            RenderUtil.render9Slice(g, tx, ty, 200, 64 + 24);

            g.renderText(
                `KEYS\n\n` +
                `[wasd] [left mouse]        move camera\n` +
                `[enter]                                     toggle world view\n` +
                `[qe]                                             zoom in and out\n` +
                `[numbers]                              start placing unit\n` +
                `\n` +
                `hover units to view details \n` +
                `drag units from bottom bar to place\n` +
                ''
                , tx + 8, ty + 14)

            y += 24;
            y += 24;
            this.renderButton(g, mxy, cx, y, 0, "BACK", null, () => {
                this.isShowingKeys = false;
            });

        } else {

            this.renderButton(g, mxy, cx, y, -devFromMid, "MUSIC", () => "MUSIC " + this.music, () => {
                this.cycleMusic();
                this.save();
            });


            this.renderButton(g, mxy, cx, y, devFromMid, "SOUND", () => "SOUND " + this.sound, () => {
                this.cycleSound();
                this.save();
            });

            y += 24;


            this.renderButton(g, mxy, cx, y, -devFromMid, "DIFFICULTY", () => this.isTutorialOn ? "TUTORIAL" : this.difficultyNames[this.difficulty], () => {
                if (this.isTutorialOn) globals.audio.playSound("nope")
                this.difficulty++;
                if (this.difficulty >= this.difficultyNames.length)
                    this.difficulty = 0;
                this.save();
            });

            this.renderButton(g, mxy, cx, y, devFromMid, "WORLD SIZE", () => this.isTutorialOn ? "TUTORIAL" : this.worldSizeNames[this.worldSize], () => {
                if (this.isTutorialOn) globals.audio.playSound("nope")
                this.worldSize++;
                if (this.worldSize >= this.worldSizeNames.length)
                    this.worldSize = 0;
                this.save();
            });

            y += 24;


            this.renderButton(g, mxy, cx, y, -devFromMid, "INPUTS", null, () => {
                this.isShowingKeys = true;
            });

            this.renderButton(g, mxy, cx, y, devFromMid, "TUTORIAL", () => this.isTutorialOn ? "YES" : "NO", () => {
                this.isTutorialOn = !this.isTutorialOn;
                this.save();
            });

            y += 24;

            if (savedGameExists) {

                this.renderButton(g, mxy, cx, y, -devFromMid, "NEW GAME", null, () => {
                    this.startGame(false);
                });

                this.renderButton(g, mxy, cx, y, devFromMid, "LOAD GAME", null, () => {
                    this.startGame(true);
                });

            } else {

                this.renderButton(g, mxy, cx, y, 0, "BEGIN", null, () => {
                    this.startGame(false);
                });
            }

        }

        // this.renderImageButton(g, mxy, g.width / zoom - 16, 2, () => "fullscreen",
        //     () => g.sketch.fullscreen(!g.sketch.fullscreen())
        // );

        this.renderImageButton(g, mxy, g.width / zoom - 10, -13, () => "panel_" + globals.panelColor, () => {
            globals.panelColor = this.cyclePanelColor(); this.save();
        });

        g.sketch.pop();

        this.wasMouseDown = g.mouseIsPressed;

        if (this.hoveredUI && this.prevHoveredUI !== this.hoveredUI) {
            globals.audio.playSound("tock")
        }
        this.prevHoveredUI = this.hoveredUI;
    }

    startGame(shouldLoad: boolean): void {
        this.save();
        setCurrentScreen(new GameScreen(
            this.isTutorialOn ? this.tutorialDifficulty : this.difficulty,
            this.isTutorialOn ? this.tutorialSize : this.worldSize,
            this.isTutorialOn,
            shouldLoad
        ))
    }





    // #region data

    save() {
        const saveData = {
            difficulty: this.difficulty,
            worldSize: this.worldSize,
            isTutorialOn: this.isTutorialOn,
            music: this.music,
            sound: this.sound,

            panelColor: globals.panelColor,
        };
        localStorage.setItem("nethereign_menu", JSON.stringify(saveData));
    }

    load() {
        const raw = localStorage.getItem("nethereign_menu");
        if (!raw) return;
        const saveData: any = JSON.parse(raw);

        if (!saveData) return;

        if (saveData.difficulty || saveData.difficulty === 0) this.difficulty = saveData.difficulty;
        if (saveData.worldSize || saveData.worldSize === 0) this.worldSize = saveData.worldSize;
        if (saveData.isTutorialOn || saveData.isTutorialOn === false) this.isTutorialOn = saveData.isTutorialOn;
        if (saveData.music !== undefined) this.music = saveData.music;
        if (saveData.sound !== undefined) this.sound = saveData.sound;

        if (saveData.panelColor) globals.panelColor = saveData.panelColor;
    }

    cyclePanelColor(): string {
        if (globals.panelColor === "purple") return "pink"
        if (globals.panelColor === "pink") return "red"
        if (globals.panelColor === "red") return "yellow"
        if (globals.panelColor === "yellow") return "brown"
        if (globals.panelColor === "brown") return "green"
        if (globals.panelColor === "green") return "cyan"
        if (globals.panelColor === "cyan") return "blue"
        if (globals.panelColor === "blue") return "gray"
        if (globals.panelColor === "gray") return "white"
        if (globals.panelColor === "white") return "purple"
        return globals.panelColor
    }

    cycleSound() {
        if (this.sound < 5) this.sound++
        else this.sound = 0


        if (this.sound === 0) {
            globals.audio.setSoundEnabled(false)
        } else {
            globals.audio.setSoundEnabled(true)
            globals.audio.setSoundVolume(this.sound / 5)
        }
        globals.audio.playSound("tick");
    }

    cycleMusic() {
        if (this.music < 5) this.music++
        else this.music = 0

        if (this.music === 0) {
            globals.audio.setMusicEnabled(false)
        } else {
            globals.audio.setMusicEnabled(true)
            globals.audio.setMusicVolume(this.music / 5)
        }
    }

    // #endregion





    // #region buttons

    renderButton(g: Graphics, mxy: Vec2, cx: number, y: number, dx: number, text1: string, text: null | (() => string), callback: () => void) {

        const w = 64 + 16;
        const h = 16;
        const x = Math.floor(cx - w / 2) + dx;

        const isHovered = Rect.isIn(mxy, { x, y, w, h });
        if (!isHovered) g.sketch.tint(255, 200)
        RenderUtil.render9Slice(g, x, y, w, h);

        const txt = isHovered && text ? text() : text1;
        const textW = g.textWidth(txt);
        g.renderText(txt, cx + dx - textW / 2, y + 10.5);

        g.sketch.tint(255, 255)

        if (isHovered) this.hoveredUI = dx + "," + y;
        if (isHovered && this.mouseJustPressed) {
            callback();
            globals.audio.playSound("tick");
        }
    }

    renderImageButton(g: Graphics, mxy: Vec2, x: number, y: number, imgName: () => string, callback: () => void) {

        const img = g.assets.getImage(imgName());
        const w = img.width;
        const h = img.height;

        const isHovered = Rect.isIn(mxy, { x, y, w, h });
        if (!isHovered) g.sketch.tint(255, 200)
        g.renderImage(imgName(), x, y);
        g.sketch.tint(255, 255)

        if (isHovered && this.mouseJustPressed) {
            callback();
            globals.audio.playSound("tick");
        }
    }
    // #endregion





    // #region particles

    spawnDustParticles(g: Graphics, ev: boolean = false): void {


        if (Math.random() < .02)
            this.targetWind = this.minWind + Math.random() * (this.maxWind - this.minWind);

        const windTimeConstant = 800;
        const smoothing = 1 - Math.exp(-g.deltaTime / windTimeConstant);
        this.currentWind += (this.targetWind - this.currentWind) * smoothing;

        const spawnChance = 0.2;
        const maxSpawnPerFrame = 2;

        for (let i = 0; i < maxSpawnPerFrame; i++) {
            if (Math.random() > spawnChance) continue;

            const startX = ev ? Math.random() * g.width : g.width;
            const startY = Math.random() * g.height;
            const speedFactor = 0.4 + Math.random() * 1.2;
            const size = Math.random() < .5 ? 4 : 6;
            const hp = 500 + Math.random() * 120;

            const red = 180 + Math.random() * 75;
            const green = 20 + Math.random() * 40;
            const blue = 20 + Math.random() * 40;
            const startAlpha = 120 + Math.random() * 90;

            let t = Math.random() * Math.PI * 2;
            const wobbleFreqX = 0.03 + Math.random() * 0.05;
            const wobbleFreqY = 0.02 + Math.random() * 0.06;
            const wobbleStrength = 0.3 + Math.random() * 0.6;
            const driftVy = (Math.random() - 0.5) * 0.3;

            g.addParticle({
                hp: hp,
                x: startX,
                y: startY,
                w: size,
                h: size,
                color: Color.col(red, green, blue, startAlpha),
                step: (p) => {
                    p.hp--;
                    t += 1;

                    const vx = -speedFactor * this.currentWind + Math.sin(t * wobbleFreqX) * wobbleStrength;
                    const vy = driftVy + Math.cos(t * wobbleFreqY) * wobbleStrength;

                    p.x += vx;
                    p.y += vy;

                    // if (p.color) {
                    //     const lifeFraction = Math.max(0, p.hp / hp);
                    //     p.color.a = startAlpha * lifeFraction;
                    // }
                }
            });
        }
    }
    // #endregion

}